const lowercaseFirstLetter = str => {
  if (!str || str.length === 0) return str
  return str.charAt(0).toLowerCase() + str.slice(1)
}

export default lowercaseFirstLetter
